import { memo } from 'react';
import type { Product } from '../../types';
import Modal from '../../../core/components/Modal';
import Markup from '../../../core/components/Markup';
import styles from './ProductAttributeVariationsModal.module.scss';

interface ProductAttributeVariationsModalProps {
    product: Product;
    onClose: () => void;
}

const ProductAttributeVariationsModal = ({
    product,
    onClose = () => {},
}: ProductAttributeVariationsModalProps) => {
    return (
        <Modal small onClose={onClose}>
            <div
                className={styles.content}
                data-test-class="variantSelectorModal"
            >
                {product.sizeSpecification && (
                    <Markup content={product.sizeSpecification} />
                )}
            </div>
        </Modal>
    );
};

export default memo(ProductAttributeVariationsModal);
